import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import DropdownMenu from './DropdownMenu';
import MobileNav from './MobileNav';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ projMouseHover, setProjMouseHover }) => {
  const [mobileOpened, setMobileOpened] = useState(false);
  const buttonSx = {
    fontSize: "18px",
    px: 2,
    py: 1,
    minHeight: "auto",
    lineHeight: 1.2,
    borderRadius: 2,
  };
  const buttonsText = [
    { name: "Home", to: "/", id: false, noRoute: "header" },
    { name: "About Me", to: "/#about-me", id: true, noRoute: "about-me" },
    { name: "DJ Booking", to: "/dj-booking", id: false, noRoute: "" },
    { name: "Resume", to: "https://github.com/ngitman/MyResume/blob/main/file.pdf", id: true, noRoute: "" },
    { name: "GitHub", to: "https://github.com/ngitman", id: true, noRoute: "" },
    { name: "Contact", to: "#contact", id: true, noRoute: "contact" }
  ];
  return (
    <header className="max-w-screen sticky top-0 mx-auto px-4 sm:px-8 py-3 sm:py-4 flex flex-col bg-white/95 backdrop-blur-md border-b border-slate-200 z-50 shadow-sm transition-all duration-300">
      <div id="header" className="flex items-center justify-between w-full max-w-7xl mx-auto">
        <Link to="/" className="group">
          <div className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-200">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow duration-200">
              <span className="text-white font-bold text-xl sm:text-2xl">NG</span>
            </div>
            <Typography
              sx={{
                fontSize: { xs: "18px", sm: "24px", md: "28px" },
                lineHeight: 1,
                fontWeight: 700,
                color: '#1e293b',
                letterSpacing: '-0.02em'
              }}
              textTransform="none"
            >
              Nicholas Gitman
            </Typography>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="lg:flex items-center ml-auto hidden h-full">
          <nav className="h-full flex items-center">
            <ul className="flex flex-row items-center gap-2">
              {buttonsText.map(b => (
                <li key={b.name}>
                  <Link to={b.to}>
                    <Button
                      sx={{
                        ...buttonSx,
                        color: '#475569',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          bgcolor: '#f1f5f9',
                          color: '#2563eb',
                        }
                      }}
                      onClick={!b.id ? null : () => {
                        window.location.href = (b.to);
                      }}
                    >
                      <Typography
                        sx={{ fontSize: '16px', fontWeight: 500 }}
                        textTransform="none"
                      >
                        {b.name}
                      </Typography>
                    </Button>
                  </Link>
                </li>
              ))}
              <li>
                <Button
                  sx={{
                    ...buttonSx,
                    color: '#475569',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      bgcolor: '#f1f5f9',
                      color: '#2563eb',
                    }
                  }}
                  onMouseEnter={() => setProjMouseHover(true)}
                  onMouseLeave={() => setProjMouseHover(false)}
                >
                  <Typography sx={{ fontSize: '16px', fontWeight: 500 }} textTransform="none">
                    Projects
                  </Typography>
                  {projMouseHover && <DropdownMenu />}
                </Button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Mobile menu button */}
        <IconButton
          size="medium"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{
            color: "#475569",
            mr: 0,
            display: { xs: 'flex', lg: 'none' },
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: '#f1f5f9',
              color: '#2563eb',
            }
          }}
          onClick={() => setMobileOpened(!mobileOpened)}
        >
          <MenuIcon />
        </IconButton>
      </div>

      {/* Mobile Navigation */}
      {mobileOpened && (
        <div className="lg:hidden w-full bg-slate-900 rounded-lg mt-3 shadow-lg animate-fade-in max-w-7xl mx-auto">
          <MobileNav
            buttonsText={buttonsText}
            buttonSx={buttonSx}
            setMobileOpened={setMobileOpened}
          />
        </div>
      )}
    </header>
  );
}

export default Header